import React from "react";
import Svg, { Path } from "react-native-svg";
import { TouchableOpacity } from "react-native";
import AppTheme from "../../AppTheme";

export default function HowIcon(props) {
  const color = props.fillColor || AppTheme.almostBlack;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7651 4.26264C9.07411 4.26264 7.70328 5.63348 7.70328 7.32449C7.70328 9.01549 9.07411 10.3863 10.7651 10.3863C12.0061 10.3863 13.0746 9.6481 13.5554 8.58685C13.5756 8.5256 13.6002 8.46676 13.6287 8.41062C13.7568 8.07306 13.827 7.70696 13.827 7.32449C13.827 5.63348 12.4561 4.26264 10.7651 4.26264ZM10.7651 12.9126C12.7078 12.9126 14.4189 11.9213 15.4203 10.417L22.3065 11.8841C22.9889 12.0295 23.6598 11.5942 23.8052 10.9119C23.9506 10.2296 23.5153 9.55863 22.833 9.41327L16.31 8.02353C16.3386 7.79453 16.3533 7.56123 16.3533 7.32449C16.3533 4.23823 13.8514 1.73633 10.7651 1.73633C7.67887 1.73633 5.17696 4.23823 5.17696 7.32449C5.17696 10.4107 7.67887 12.9126 10.7651 12.9126ZM5.5087 14.7213C5.12586 14.7157 4.76111 14.8839 4.51696 15.1789L0.526962 19.9989C0.214901 20.3759 0.148667 20.8992 0.356965 21.342C0.565264 21.7848 1.01061 22.0675 1.49999 22.0675H13.14C13.5377 22.0675 13.9121 21.8802 14.1506 21.5621L17.6406 16.9071C17.9256 16.527 17.9732 16.0192 17.7639 15.5927C17.5546 15.1663 17.1237 14.8934 16.6487 14.8863L5.5087 14.7213ZM4.18543 19.5412L6.07683 17.2563L14.1319 17.3756L12.5083 19.5412H4.18543Z"
          fill={color}
        />
      </Svg>
    </TouchableOpacity>
  );
}
